/* istanbul ignore file */
// libs
import { Routes } from 'react-router-dom';
// components
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { READ_PERFORMANCE_REPORT } from 'domain/people/employee/performanceReport/usePerformanceReportService';
import { createRoute, Route } from 'framework/routing';
import PerformanceReportsListPage from 'domain/people/employee/performanceReport/List';
import { ProtectedRoute } from 'framework/authorization';

const PERFORMANCE_REPORTS_PATH = '/performance-report';
const PERFORMANCE_REPORT_ID_SOURCE = 'performanceReportId';

const usePerformanceReportsRoute = () => {
  return createRoute({
    singleEntityRoute: `/:${PERFORMANCE_REPORT_ID_SOURCE}?`,
    listRoute: `${PERFORMANCE_REPORTS_PATH}`,
  });
};

const PerformanceReportRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { singleEntityRoute } = usePerformanceReportsRoute();

  return (
    <Routes>
      <Route
        path={singleEntityRoute}
        element={
          <ProtectedRoute permissionToCheck={READ_PERFORMANCE_REPORT}>
            <PerformanceReportsListPage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

export default PerformanceReportRouter;
